import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
	walletPaymentActions,
	walletPaymentSelectors,
	generalSelectors,
	walletPaymentTypes,
} from 'Ducks';
import { composeClassNames, convertRialToToman } from 'Helpers';
import Input from 'Components/Globals/Elements/Input/loadable';
import Icon from 'Components/Globals/Elements/Icon/loadable';
import Button from 'Components/Globals/Elements/Button';
import Guide from 'Assets/images/payment/Guide.jpg';
import useServices from 'Hooks/useServices';
import useContent from 'Hooks/useContent';
import GENERAL_REGEX from 'Helpers/regex';

import styles from './styles.module.scss';
import strings from './strings';

function ManualBarcode() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { business } = useServices();

	const { formatMessage } = useContent();
	const [barcode, setBarcode] = useState('');
	const id = useSelector(walletPaymentSelectors.selectTransactionId);
	const amount = useSelector(walletPaymentSelectors.selectAmount) ?? 0;
	const isLoading = useSelector((state) =>
		generalSelectors.selectApiLoadingStatus(
			state,
			walletPaymentTypes.CHECK_BARCODE.REQUEST
		)
	);

	const inputWrapperRef = useRef(null);
	const onSubmitBarcode = (valueOverride) => {
		dispatch(
			walletPaymentActions.checkBarcodeRequest({
				id,
				barcode: valueOverride ?? barcode,
				business,
				successEventName: 'wallet_barcode_manual_submit_success',
				failedEventName: 'wallet_barcode_manual_submit_invalid_barcode_error',
				navigate,
			})
		);
	};
	useEffect(() => {
		let rafId;

		const tryFocus = () => {
			const wrapper = inputWrapperRef.current;
			if (!wrapper) {
				rafId = requestAnimationFrame(tryFocus);
				return;
			}
			const inputEl = wrapper.querySelector('input');
			if (inputEl && document.activeElement !== inputEl) {
				inputEl.focus();
			} else if (!inputEl) {
				rafId = requestAnimationFrame(tryFocus);
			}
		};

		rafId = requestAnimationFrame(tryFocus);
		return () => cancelAnimationFrame(rafId);
	}, []);

	return (
		<div className={styles.wrapper}>
			<p className='txt-gray text-center m-16 mt-24 sm'>
				{formatMessage(strings.description)}
			</p>
			<div className={`bg-base p-8 m-16 ${styles.discount_wrapper}`}>
				<p className='sm txt-dark line-height-24 bold'>
					{formatMessage(strings.amount)}
				</p>
				<div className={styles.discount_amount_wrapper}>
					<p className='txt-dark md line-height-24 bold'>
						{convertRialToToman(amount).replaceAll(',', '،')}
					</p>
					<Icon
						name='toman'
						size='xs'
						className='txt-dark'
					/>
				</div>
			</div>
			<div ref={inputWrapperRef}>
				<Input
					name='barcode'
					className={composeClassNames(['mv-8 mh-16', styles.input])}
					value={barcode}
					label={formatMessage(strings.title)}
					onChange={(value) => {
						value = value.replace(GENERAL_REGEX.removeNonDigit.pattern, '');
						setBarcode(value);
					}}
					onPaste={(e) => {
						const pastedValue = e.clipboardData.getData('text');
						setBarcode(pastedValue);
						setTimeout(() => onSubmitBarcode(pastedValue), 0);
					}}
					textCenter
					type='tel'
					inputMode='numeric'
					pattern='[0-9]*'
					maxLength={26}
					autoFocus
				/>
			</div>

			<div className='m-16 mt-24'>
				<img
					src={Guide}
					className={styles.guide}
					alt='Guide'
				/>
			</div>
			<Button
				label={formatMessage(strings.buttonLabel)}
				onClick={() => onSubmitBarcode()}
				className={composeClassNames(['m-16', styles.button])}
				disabled={!barcode || barcode.length < 8}
				isLoading={isLoading}
			/>
		</div>
	);
}

export default ManualBarcode;
